<script lang="ts">
    import { mdiClose, mdiCloseCircleOutline } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import { overlayTabs, operationHashBeginning } from "../../store"
    import { tick } from "svelte"
    import { icons } from "../../config"
    import Modal from "./Modal.svelte"
    import { _ } from "svelte-i18n"
    import { evokeCallbacks, checkForRegisteredEvents, unregisterAllEventCallbacks } from "../../eventBus"

    export let lang = "de"

    let activeTab: OverlayTab
    let scrollY: any
    $: showOverlay = !!$overlayTabs?.length

    let fadeIn: boolean = false

    $: {
        activeTab = undefined
        if ($overlayTabs?.length) {
            fadeIn = true

            for (let i = $overlayTabs.length - 1; i >= 0; i--) {
                if ($overlayTabs[i].active) {
                    activeTab = $overlayTabs[i]
                    break
                }
            }
        }
    }

    const body = document.body
    let oldOpenState = showOverlay
    let scrollState: number

    $: if (oldOpenState != showOverlay) {
        if (showOverlay) {
            scrollState = scrollY
            body.style.top = `-${scrollY}px`
            body.style.position = "fixed"
            body.style.right = "0px"
            body.style.left = "0px"
        } else {
            body.style.position = "relative"
            body.style.top = ""
            window.scrollTo(0, scrollState)
        }
        oldOpenState = showOverlay
    }

    let tabDiv: HTMLElement

    function scrollToTab() {
        tick().then(() => {
            const activeElement = tabDiv.querySelector(".item.active") as HTMLElement
            tabDiv.scrollLeft = activeElement.offsetLeft - 20
        })
    }

    let closeRequestFn: () => void

    function closeTab(tab: OverlayTab, force = false) {
        let closeEvents = checkForRegisteredEvents("closeOpTab")
        if (closeEvents) {
            let closePermission = evokeCallbacks("closeOpTab", { id: activeTab?.props?.id })
            if (!closePermission && !force) {
                closeRequestFn = () => {
                    unregisterAllEventCallbacks("closeOpTab")
                    closeTab(tab)
                    closeRequestFn = null
                }
                return
            }
        }
        $overlayTabs =
            $overlayTabs?.filter((t) => {
                return t != tab
            }) || []

        if ($overlayTabs.length && tab.active) {
            $overlayTabs[$overlayTabs.length - 1].active = true
        }
        if (!$overlayTabs.length) {
            $operationHashBeginning = null
        }
    }

    let oldTab = activeTab
    $: if (tabDiv && activeTab && activeTab != oldTab) {
        scrollToTab()
        oldTab = activeTab
    }

    const closeOverlay = () => {
        let closeEvents = checkForRegisteredEvents("closeOpTab")
        if (closeEvents) {
            let closePermission = evokeCallbacks("closeOpTab", {})
            if (!closePermission) {
                closeRequestFn = () => {
                    unregisterAllEventCallbacks("closeOpTab")
                    closeOverlay()
                    closeRequestFn = null
                }
                return
            }
        }

        fadeIn = false
        $overlayTabs = null
        showOverlay = false
        $operationHashBeginning = null
    }
</script>

<svelte:window
    on:keydown="{(e) => {
        if (e.key == 'Escape') {
            closeOverlay()
        }
    }}"
    bind:scrollY
/>

{#if showOverlay}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div id="overlay" class:open="{fadeIn}" data-lang="{lang}" on:click|stopPropagation on:scroll|stopPropagation>
        <div class="inner">
            <div class="overlaytop">
                <div class="tabs" bind:this="{tabDiv}">
                    {#each $overlayTabs || [] as tab}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                        <div
                            class="item"
                            class:active="{tab.active}"
                            class:out="{tab.props?.collectionName === 'operation-out'}"
                            on:click="{() => {
                                $overlayTabs?.forEach((t) => {
                                    if (t == tab) t.active = true
                                    else t.active = false
                                })

                                $overlayTabs = $overlayTabs
                            }}"
                        >
                            <div class="type">
                                {#if tab.props?.collectionName === "operation-out"}
                                    {#if tab?.props?.type == 1}
                                        <span class="icon"><Icon path="{icons.offerOut}" viewBox="0 0 200 200" /></span>
                                    {:else}
                                        <span class="icon">
                                            <Icon path="{icons.order}" viewBox="0 0 180.2 203.87" />
                                        </span>{/if}
                                {:else if tab?.props?.type == 1}
                                    <span class="icon"><Icon path="{icons.offerIn}" viewBox="0 0 214.13 214.13" /></span
                                    >{:else}
                                    <span class="icon">
                                        <Icon path="{icons.order}" viewBox="0 0 180.2 203.87" />
                                    </span>{/if}
                                <span class="text">{tab.title}</span>
                            </div>
                            <div class="headline">
                                ({tab.props?.collectionName === "operation-out"
                                    ? $_("general.exit")
                                    : $_("general.entrance")})
                                {tab.subtitle || ""}
                            </div>
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div
                                class="close_white"
                                on:click|stopPropagation="{() => {
                                    closeTab(tab)
                                }}"
                            >
                                <Icon path="{mdiCloseCircleOutline}" size="18px" />
                            </div>
                        </div>
                    {/each}
                </div>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div class="close" on:click="{closeOverlay}">
                    <Icon path="{mdiClose}" size="24px" />
                </div>
            </div>

            {#if activeTab}
                {#key activeTab}
                    <div class="overlaycontent">
                        <svelte:component
                            this="{activeTab.component}"
                            {...activeTab.props}
                            closeCallback="{() => {
                                closeTab(activeTab)
                            }}"
                            on:closeModal="{() => {
                                $overlayTabs?.forEach((tab) => closeTab(tab, true))
                            }}"
                            on:hideOverlay="{() => {
                                fadeIn = false
                                $overlayTabs = null
                                showOverlay = false
                                $operationHashBeginning = null
                            }}"
                            on:closeTab="{() => {
                                closeTab(activeTab)
                            }}"
                        />
                    </div>
                {/key}
            {/if}
        </div>
    </div>
{/if}

{#if closeRequestFn}
    <Modal
        show="{true}"
        on:close="{() => {
            closeRequestFn = null
        }}"
        showCloseIcon="{false}"
    >
        <div slot="header">{$_("components.overlay.closeOffer")}</div>
        <div>{$_("components.overlay.unsavedChanges")}</div>
        <div slot="footer">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    closeRequestFn = null
                }}">{$_("general.no")}</button
            >
            <button
                class="btn"
                on:click="{() => {
                    closeRequestFn()
                }}">{$_("general.yes")}</button
            >
        </div>
    </Modal>
{/if}
